export default __webpack_public_path__ + "static/media/BrandocVillageEastMap.99d67606.jpg";